import clsx from 'clsx';
import React from 'react';

import { Typography } from '@/components/atoms/Typography';

interface Props {
  firstTitle?: string;
  secondTitle?: string;
  id?: string;
}

export const PageTitle: React.FC<Props> = ({ firstTitle, secondTitle, id }: Props) => {
  return (
    <div id={id} className={'justify-center flex w-full rounded-b-3xl bg-primary'}>
      <div className={clsx(' pb-3 pt-3 md:pt-0 px-2 text-center md:px-32 ')}>
        {secondTitle ? (
          <Typography variant="h1" color="white">
            {firstTitle} <strong>{secondTitle}</strong>
          </Typography>
        ) : (
          <Typography variant="h2" color="white">
            {firstTitle}
          </Typography>
        )}
      </div>
    </div>
  );
};
